import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useCallback } from "react";

export default function PopularRentalCarsCampaign({
    campaign,
    searchProps,
    activeClass
}) {
    const handleClick = useCallback(() => {
    }, [activeClass]);

    return (
        <>
            <FontAwesomeIcon className="w-min text-second-color" fontSize={30} icon={byPrefixAndName.far['ticket']}/>
            <div className="font-sofia-sans font-semibold text-lg leading-[24px]">
                {campaign?.Text}
            </div>
            <div className="w-full relative mt-4 min-w-[275px] flex justify-center">
                <div
                    className={`relative flex flex-col gap-4 p-3 pb-2 w-[200px] lg:w-[229px] cursor-pointer`}
                    onClick={handleClick}
                >
                    <figure
                        className="absolute top-0 start-0 w-full h-full before:content-['']
                           before:absolute before:top-[55%] before:translate-y-[-55%]
                           before:left-[50%] before:translate-x-[-50%] before:w-[90%]
                           before:border-b-2 before:border-dashed before:border-border-light-grey
                          "
                    >
                        <Image
                            src={generateCdnUrl({ src: `v1745238952/Images/Car/CarSearchPage/CampaignCard/CarSearchCampaignCard.svg` })}
                            width={0}
                            height={0}
                            sizes="100vw"
                            style={{ width: 'auto', height: '100%'}}
                            alt={campaign?.Text}
                        />
                    </figure>

                    <div className="w-full flex justify-between z-10">
                        <figure className="h-8">
                            <Image
                                src={campaign?.LogoUrl}
                                width={0}
                                height={0}
                                sizes="100vw"
                                alt={campaign?.Text}
                                className="object-contain h-full w-auto"
                            />
                        </figure>

                        <span
                            className={`w-6 min-w-6 h-6 cursor-pointer 
                                border border-solid border-[#BCBEBF] rounded bg-[#FAFAFB]
                                `
                            }
                        />
                    </div>

                    <div
                        className="text-[#1F1DB6] flex gap-1 font-medium text-sm z-10"
                    >
                        <FontAwesomeIcon fontSize={18} icon={byPrefixAndName.far['circle-info']}/>

                        <div className="max-w-[175px] lg:max-w-[150px] truncate">
                            {campaign?.DiscountText}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}